module.exports = __webpack_public_path__ + "static/stone_juggernaut-17ff57f0bd59ab1b188d5663c7eff83d.png";